export const FrontEndErrors = {
  fontend_error0: "Unkown Error Occured",
  frontend_error1: "Invalid Data",
};
